/* @ngInject */
function CheckboxInputController () {
  var ctrl = this

  ctrl.$onInit = function () {
    ctrl.value = ctrl.field.value === 'true'
  }

  ctrl.changeValue = function () {
    this.onChange({ value: this.value })
  }
  ctrl.$onChanges = ctrl.$onInit
}

export { CheckboxInputController }
